<template>
    <div class="cps-main-page">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
            <el-breadcrumb-item>礼包管理</el-breadcrumb-item>
            <el-breadcrumb-item>抽奖记录列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>
        <div class="page-content">
            <el-row @keyup.enter.native="loadData(1)">
                <el-input v-model="queryField.userId" size="small" placeholder="用户ID"></el-input>
                <el-input v-model="queryField.awardId" size="small" placeholder="奖励ID"></el-input>
                <el-select v-model="queryField.provide" size="small" placeholder="奖励状态">
                    <el-option
                        v-for="item in optionsProvide"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-search" size="small" @click="loadData(1)">查询</el-button>
                <el-button type="primary" icon="el-icon-search" size="small" @click="reset">重置</el-button>
            </el-row>
            <el-table class="cps-table-data"
                      :data="tableData" size="small"
                      border
                      :height="height"
                      style="width: 100%">
                <el-table-column
                    prop="userId"
                    label="用户ID"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="awardId"
                    label="奖品ID"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="awardName"
                    label="奖品名"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="thirdUserName"
                    label="微信昵称"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="infoCode"
                    label="微信唯一标志"
                    width="250">
                </el-table-column>
                <el-table-column
                    prop="gainTime"
                    label="中奖时间"
                    width="140">
                </el-table-column>
                <el-table-column
                    prop="provide"
                    label="是否已发放奖品"
                    width="120">
                    <template slot-scope="scope">
                        <span style="color: #E6A23C;font-weight: bold" v-if="scope.row.provide === 0">未通过</span>
                        <span style="color: #5eb632;font-weight: bold" v-if="scope.row.provide === 1">已通过</span>
                        <span style="color: #81897f;font-weight: bold" v-if="scope.row.provide === 2">无需发放</span>
                    </template>
                </el-table-column>

                <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.provide === 0" type="text" size="small"
                                   @click="toPass(scope.row.id)">通过
                        </el-button>
                        <el-button v-if="scope.row.provide === 1" type="text" size="small"
                                   @click="toRepeal(scope.row.id)">撤销
                        </el-button>
                        <el-button type="text" size="small" @click="redPacketStatus(scope.row.id)">查询红包状态
                        </el-button>
                        <el-button v-if="scope.row.provide === 0" type="text" size="small"
                                   @click="resendRedPacket(scope.row)">重新发放红包
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="cps-table-data"
                           @current-change="loadData"
                           background
                           :page-size="18"
                           :current-page="currentIndex"
                           layout="total, prev, pager, next"
                           :total="total">
            </el-pagination>


        </div>
    </div>
</template>
<script>
import {
    queryAwardProvideList,
    queryRedPacket,
    resendRed,
    updateProvide,
    loadGame,
    updatePass,
    updateRepeal
} from "@/api/request";

export default {
    name: 'provideList',
    inject: ['reload'],
    data() {
        return {
            //判断
            isSupper: false,

            //数据
            tableData: [],

            currentIndex: 1,
            total: 0,
            height: window.innerHeight - 210,

            restaurants3: [],

            optionsProvide: [
                {
                    value: '',
                    label: ' 奖品状态'
                }, {
                    value: '0',
                    label: '未通过'
                }, {
                    value: '1',
                    label: '已通过'
                }],
            //模型
            queryField: {
                userId: '',
                awardId: '',
                provide: '',
                drawId: ''
            },

            form: {},
        };
    },
    mounted() {
        let user = JSON.parse(localStorage.getItem("userInfo"));
        this.isSupper = user.groupId === "1";
        this.loadData(1);
    },
    methods: {
        handleSelect3(item) {
            this.queryField.drawId = item
        },
        loadGame(query) {
            if (query !== '') {
                let me = this;
                loadGame(query).then(res => {
                    me.restaurants3 = [];
                    res.data.data.forEach(function (e) {
                        let item = {}
                        item.key = e.game_id
                        item.value = e.game_id
                        item.label = e.game_name
                        me.restaurants3.push(item)
                    })
                })
            }
        },
        cancelReadOnly(value) {
            this.$nextTick(() => {
                if (!value) {
                    const {selectGame} = this.$refs;
                    const input = selectGame.$el.querySelector(".el-input__inner");
                    input.removeAttribute("readonly");
                    this.$refs.selectGame.blur();
                }
            });
        },

        reset() {
            this.queryField.userId = '';
            this.queryField.awardId = '';
            this.queryField.provide = '';
            this.queryField.drawId = '';
        },

        loadData(index) {
            let params = {
                pageNo: index,
                pageSize: 18,
                params: this.queryField,
            }
            queryAwardProvideList(params).then(res => {
                this.tableData = res.data.list;
                this.total = res.data.total;
                this.currentIndex = index;
            })
        },
        toPass(id) {
            this.$confirm(`确定通过该奖品发放吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                updatePass(id).then(res => {
                    if (res.data.success) {
                        this.$message.success(`发放成功`);
                        this.loadData(this.currentIndex);
                    } else {
                        this.$message.error(res.data.error.message);
                    }
                })
            });
        },
        toRepeal(id) {
            this.$confirm(`确定撤销该奖品发放吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                updateRepeal(id).then(res => {
                    if (res.data.success) {
                        this.$message.success(`撤销成功`);
                        this.loadData(this.currentIndex);
                    } else {
                        this.$message.error(res.data.error.message);
                    }
                })
            });
        },
        redPacketStatus(provideId) {
            queryRedPacket(provideId).then(res => {
                if (res.data.success) {
                    this.$alert("红包领取状态：" + this.redPacketStatusFormat(res.data.data));
                } else {
                    this.$message.error(res.data.error.message);
                }
            })
        },
        resendRedPacket(obj) {
            let params = {
                id: obj.id,
                openid: obj.infoCode,
                awardId: obj.awardId
            }
            resendRed(params).then(res => {
                if (res.data.success) {
                    this.$message.success("发放成功");
                } else {
                    this.$message.error(res.data.error.message);
                }
            })
        },
        //工具类
        refresh() {
            this.reload()
        },
        redPacketStatusFormat(cellValue) {
            let rep = "";
            if (cellValue === "SENDING") {
                rep = "发放中";
            } else if (cellValue === "SENT") {
                rep = "已发放待领取";
            } else if (cellValue === "FAILED") {
                rep = "发放失败";
            } else if (cellValue === "RECEIVED") {
                rep = "已领取";
            } else if (cellValue === "RFUND_ING") {
                rep = "退款中";
            } else if (cellValue === "REFUND") {
                rep = "已退款";
            }
            return rep;
        }
    }
}
</script>
<style lang="scss" scoped>
.cps-main-page {
    .cps-table-data {
        td {
            .el-image {
                display: inherit;
            }
        }
    }
}
</style>

